module.exports = __webpack_public_path__ + "public/img/idCard.77f704a6.png";